<div class="incoterms-side-bar">
  <div class="incoterms-side-bar-header">
    <app-switch-button
      [control]="shippingRoleSwitchControl"
      [textLeft]="'IMPORT' | translate"
      [textRight]="'LABELS.EXPORT' | translate"
      [isLeftActive]="isLeftSwitchActive"
      [isRightActive]="isRightSwitchActive"
    ></app-switch-button>

    <app-hint-tooltip-icon [isHideCircle]="true" [isShowCustom]="true" [isSkipMobileModal]="true" [hint]="incotermsHeaderHint">
      <ng-container hint-container>
        <div class="incoterms-side-bar-label">
          {{ incotermsHeaderLabel | translate }}
        </div>
      </ng-container>
    </app-hint-tooltip-icon>
  </div>

  <lcl-incoterms-items
    [isHighlighted]="true"
    [incotermsControl]="incotermsControl"
    [currentShippingRole]="currentShippingRole"
    (changeIncotermsSource)="setIncoterms($event)"
  ></lcl-incoterms-items>

  <div class="switch-incoterms-warning" *ngIf="incotermsControl.value !== enumIncotermsType.FOB">
    <span class="switch-incoterms-warning__header" *ngIf="isChangeFOBToFCA">
      {{ "LABELS.SWITCHING_INCOTERMS" | translate }}
    </span>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="exportLicenseRequested" [formControl]="exportLicenseRequestedControl" />
      <label class="custom-control-label switch-incoterms-warning__description" for="exportLicenseRequested">
        <span class="text">{{ "LABELS.BUY_EXPORT_LICENSE" | translate }}</span>
        <span class="sub-text">{{ "LABELS.BUY_EXPORT_LICENSE_DESCRIPTION" | translate }}</span>
      </label>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-center">
    <button class="btn btn-primary" [disabled]="formGroup.invalid" (click)="save()">{{ "BUTTON.SAVE" | translate }}</button>
  </div>
</div>
